import React from 'react';

const Loader = ({ isVisible = true }) => {
  return (
    <div className={`loader-container ${!isVisible ? 'loader-fade-out' : ''}`}>
      <div className="loader-content">
        <div className="loader-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <div className="loader-text">
          <h2>Loading Experience...</h2>
          <p>Preparing digital excellence for you</p>
        </div>
      </div>
    </div>
  );
};

export default Loader;
